<template>
    <span  class="el-parent-input" v-if="!data || data === 'empty'">
        <el-input
            v-bind:class="type === isType ? (value && !error_msg ? 'success' : 'danger') : (error_msg ? 'danger' : '')"
            v-bind:value="value"
            @blur="onBlur(type, name, $event)"
            @input="onChange(type, name, $event)"
            :placeholder="placeholder"
            :type="inputType"
            size="small"
            autosize
        ></el-input>
        <span class="txt-danger">{{error_msg}}</span>
    </span>
    <span v-else>{{ data }}</span>
</template>
<script>
export default {
    name: 'resolve-by-text',
    data() {
        return {
            value: this.initialValue,
            error_msg: ""
        }
    },
    props: {
        isType: {
            type: String,
            required: true
        },
        data: {
            type: [String, Boolean],
            required: true
        },
        type: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: true
        },
        inputType: {
            type: String,
            default: "text"
        },
        name: {
            type: String,
            required: true
        },
        initialValue: {
            type: String
        }
    },
    methods: {
        onChange(type, name, event) {
            this.error_msg = ""
            this.value = event
            this.$emit("changeText", {
                type, name, event: this.value
            })
        },
        onBlur(type, name, event) {
            // if(this.isType === "email" && !this.validateEmail(this.value)) {
            //     this.error_msg = "Enter a valid email"
            // }
            // if(this.isType === "phone" && !this.validatePhone(this.value)) {
            //     this.error_msg = "Enter a valid phone no."
            // }
        },
        validateEmail(email) {
            if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)) {
                return true
            }
            return false
        },
        validatePhone(phone) {
            const PHONE_REGEX = /(\+1)?[(]?\d{3}[)]?[(\s)?.-]?\d{3}[\s.-]?\d{4}/
            if(PHONE_REGEX.test(phone)) {
                return true
            }
            return false
        }
    }
}
</script>
<style lang="scss">
    .el-parent-input{
        position: relative;
        display: inline-block;
        .txt-danger {
            display: inline-block;
            color: #f56c6c !important;
            position: absolute;
            width: 100%;
            bottom: -13px;
            left: 0;
        }
            .el-textarea {
        textarea {
            max-height: 70px;
        }
    }
    }

    .success {
        input {
            border-color: rgb(103, 194, 58) !important;
            background-color: #f6fff8;
        }
    }

    .danger {
        input {
            border-color: rgb(245, 108, 108) !important;
        }
    }
</style>